import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { User } from 'src/app/models/user.model';
import { AuthService } from 'src/app/services/auth/auth.service';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { RapidGlobalInfo } from 'src/app/models/user.model';
import { SiteInductionInfo } from 'src/app/models/user.model';
import { NavigationService } from 'src/app/services/navigation/navigation.service';
import { UserService } from 'src/app/services/user/user.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { SiteInductionAddEditComponent } from '../site-induction-add-edit/site-induction-add-edit.component';
import { SiteInductionDeleteComponent } from '../../components/site-induction-delete/site-induction-delete.component';
import { LocalizationService } from '../internationalization/localization.service';
import { Camera, CameraDirection, CameraResultType } from '@capacitor/camera';
import { FileStorageService } from 'src/app/services/filestorage/filestorage.service';
import { environment } from 'src/environments/environment';
import { UploadFileStorage } from 'src/app/models/filestorage.model';
import { UtilsService } from 'src/app/services/util/util-service';
import { UserProfileDeleteComponent } from '../user-profile-delete/user-profile-delete.component';
import { RapidGlobalDeleteComponent } from '../rapid-global-delete/rapid-global-delete.component';
import { RapidGlobalAddEditComponent } from '../rapid-global-add-edit/rapid-global-add-edit.component';
import { ConfigurationService } from '@app/services/configuration/configuration.service';
import { MatTableDataSource } from '@angular/material/table';
import { Language } from '@app/models/language.model';
import { DeviceDetectorService } from 'ngx-device-detector';
import { UserdebuginfoService } from '@app/services/userdebuginfo/userdebuginfo.service';
import { GeolocationService } from '@app/services/geolocation/geolocation.service';
import { Capacitor } from '@capacitor/core';
import { SiteInductionStatus } from 'src/app/shared/enums';


@Component({
    selector: 'app-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.scss'],
    animations: [
        trigger('detailRapidExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
        trigger('detailInductionExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: false
})
export class UserProfileComponent implements OnInit {
  public userProfileFormGroup!: UntypedFormGroup;
  currentUser: User | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  emailAddress: string | undefined;
  phoneNumber: string | undefined;
  profileImgLink: string | undefined;
  newImagePath: string | undefined;
  newImageFormat: string | undefined;
  rapidGlobalInfos: MatTableDataSource<RapidGlobalInfo> = new MatTableDataSource<RapidGlobalInfo>([]);
  displayedRapidGlobalColumns: string[] = ['companyName', 'status'];
  expandedRapidElement: RapidGlobalInfo | undefined;
  siteInductionInfos: MatTableDataSource<SiteInductionInfo> = new MatTableDataSource<SiteInductionInfo>([]);
  displayedSiteInductionColumns: string[] = ['brandName', 'status'];
  expandedInductionElement: SiteInductionInfo | undefined;
  inductionModuleEnable: boolean = false;
  profileInductionRequired: boolean = false;
  profileRapidGlobalRequired: boolean = false;
  isSSO: boolean = false;
  loginTypes: string[] = ['apple', 'google'];
  isMutliLanguageEnable: boolean = false;
  language: string = environment.defaultLang;
  languages: Language[] = [];
  isDebugModeActive: boolean = false;
  currentDateTime: Date = new Date();
  appVersion: string = environment.appVersion;
  deviceInfo: string = "";
  userLatLong: string = "";
  readonly SiteInductionStatus = SiteInductionStatus;

  @ViewChild('img') imgEl: ElementRef | undefined;
  output: string = '';

  constructor(private _authService: AuthService,
    private _router: Router,
    private formBuilder: UntypedFormBuilder,
    private _navigationService: NavigationService,
    private _userService: UserService,
    private _addDialog: MatDialog,
    private _localizationService: LocalizationService,
    private _fileStorageService: FileStorageService,
    private _utilsService: UtilsService,
    private _configurationService: ConfigurationService,
    private _deviceService: DeviceDetectorService,
    private _userdebuginfoService: UserdebuginfoService,
    private _geolocationService: GeolocationService,
  ) {
    this._navigationService.onChange(true, false);
    this.userProfileFormGroup = this.initUserProfileForm();
  }

  async ngOnInit(): Promise<void> {
    this.inductionModuleEnable = await this._configurationService.getInductionModuleEnable();
    this.profileInductionRequired = await this._configurationService.getProfileInductionRequired();
    this.profileRapidGlobalRequired = await this._configurationService.getProfileRapidGlobalRequired();

    this.language = await this._localizationService.get() ?? environment.defaultLang;
    this.isMutliLanguageEnable = await this._configurationService.getIsMultiLanguageEnable();
    if (this.isMutliLanguageEnable) {
      this._localizationService.getLanguages().subscribe({
        next: async (langs) => {
          this.languages = [...langs];
        }
      });
    }

    this.loadUser(true);
  }

  private initUserProfileForm(): UntypedFormGroup {
    const userProfileFormGroup = this.formBuilder.group({});
    return userProfileFormGroup;
  }

  private setCurrentUser(user: User): void {
    this.currentUser = user;
    this.firstName = this.currentUser.firstName;
    this.lastName = this.currentUser.lastName;
    this.emailAddress = this.currentUser.emailAddress;
    this.phoneNumber = this.currentUser.mobileNumber;
    this.getProfileImageLink(this.currentUser.photo);
    this.rapidGlobalInfos.data = this.currentUser.rapidGlobalInfos;
    this.siteInductionInfos.data = this.currentUser.siteInductionInfos;
    this.isDebugModeActive = this.currentUser.isDebugModeActive;
  }


  private async loadUser(refreshUser: boolean): Promise<void> {

    var user = await this._authService.getUser();
    await this.getUserDomain();
    await this.getLoginType();
    if (user) {
      if (refreshUser) {
        this.setCurrentUser(user);
        this.refreshInductionsFromApi();
      } else this.setCurrentUser(user)
    }
    else alert(this._localizationService.translate('loginuser_email_usernotfound'));
  }

  private async getUserDomain(): Promise<void> {
    try {
      this.isSSO = await this._authService.getSSODomain();
    } catch (error) {
      alert(error);
    }
  }

  private async getLoginType(): Promise<void> {
    try {
      const loginType = await this._authService.getLoginType();

      if (loginType && this.loginTypes.includes(loginType)) {
        this.isSSO = true;
      }

    } catch (error) {
      alert(error);
    }
  }

  getStatus(item: any): string {
    return item.status;
  }

  public closeUserProfile(): void {
    this._router.navigate(['signin']);
  }

  public async changepassword(): Promise<void> {
    await this._authService.resetPassword(this.currentUser?.emailAddress!);
  }

  public async updateUserDetails(): Promise<void> {
    if (this.currentUser)
      await this._authService.updateUserDetails(this.currentUser);
  }

  addRapidGlobal() {
    let addRapidDialog: MatDialogRef<RapidGlobalAddEditComponent>;
    const dialogConfig = {
      data: { user: this.currentUser, isEditMode: false },
      disableClose: true,
      autoFocus: false,
      panelClass: 'details-container'
    };
    addRapidDialog = this._addDialog.open(RapidGlobalAddEditComponent, dialogConfig);
    addRapidDialog.addPanelClass('details-container');
    addRapidDialog.afterClosed().subscribe((returnValue) => {
      if (returnValue) {
        this._authService.setUser(returnValue);
        this.loadUser(false);
      }
    });
  }

  editRapidGlobal(item: RapidGlobalInfo | undefined) {
    let addRapidDialog: MatDialogRef<RapidGlobalAddEditComponent>;
    const dialogConfig = {
      data: { user: this.currentUser, rapid: item, isEditMode: true },
      disableClose: true,
      autoFocus: false,
      panelClass: 'details-container'
    };
    addRapidDialog = this._addDialog.open(RapidGlobalAddEditComponent, dialogConfig);
    addRapidDialog.addPanelClass('details-container');
    addRapidDialog.afterClosed().subscribe((returnValue) => {
      if (returnValue) {
        this._authService.setUser(returnValue);
        this.loadUser(false);
      }
    });
  }

  deleteRapidGlobal(item: RapidGlobalInfo | undefined) {
    let deleteRapidDialog: MatDialogRef<RapidGlobalDeleteComponent>;
    const dialogConfig = {
      data: { user: this.currentUser, rapid: item },
      disableClose: true,
      autoFocus: false,
      panelClass: 'details-container'
    };
    deleteRapidDialog = this._addDialog.open(RapidGlobalDeleteComponent, dialogConfig);
    deleteRapidDialog.addPanelClass('details-container');
    deleteRapidDialog.afterClosed().subscribe((returnValue) => {
      if (returnValue) {
        this._authService.setUser(returnValue);
        this.loadUser(false);
      }
    });
  }

  addSiteInduction() {
    let addInductionDialog: MatDialogRef<SiteInductionAddEditComponent>;
    const dialogConfig = {
      data: { user: this.currentUser, isEditMode: false },
      disableClose: true,
      autoFocus: false,
      panelClass: 'details-container'
    };
    addInductionDialog = this._addDialog.open(SiteInductionAddEditComponent, dialogConfig);
    addInductionDialog.addPanelClass('details-container');
    addInductionDialog.afterClosed().subscribe((returnValue) => {
      if (returnValue) {
        this._authService.setUser(returnValue);
        this.loadUser(false);
      }
    });
  }

  editSiteInduction(item: SiteInductionInfo | undefined) {
    let addInductionDialog: MatDialogRef<SiteInductionAddEditComponent>;
    const dialogConfig = {
      data: { user: this.currentUser, induction: item, isEditMode: true },
      disableClose: true,
      autoFocus: false,
      panelClass: 'details-container'
    };
    addInductionDialog = this._addDialog.open(SiteInductionAddEditComponent, dialogConfig);
    addInductionDialog.addPanelClass('details-container');
    addInductionDialog.afterClosed().subscribe((returnValue) => {
      if (returnValue) {
        this._authService.setUser(returnValue);
        this.loadUser(false);
      }
    });
  }

  deleteSiteInduction(item: SiteInductionInfo | undefined) {
    let deleteInductionDialog: MatDialogRef<SiteInductionDeleteComponent>;
    const dialogConfig = {
      data: { user: this.currentUser, induction: item },
      disableClose: true,
      autoFocus: false,
      panelClass: 'details-container'
    };
    deleteInductionDialog = this._addDialog.open(SiteInductionDeleteComponent, dialogConfig);
    deleteInductionDialog.addPanelClass('details-container');
    deleteInductionDialog.afterClosed().subscribe((returnValue) => {
      if (returnValue) {
        this._authService.setUser(returnValue);
        this.loadUser(false);
      }
    });
  }

  refreshInductionsFromApi(): void {
    if (!this.currentUser?.siteInductionInfos || this.currentUser.siteInductionInfos.length === 0)
      return;

    const currentUser = this.currentUser;
    const pending = currentUser.siteInductionInfos.filter(i => !!i.inductionId);
    if (pending.length === 0)
      return;

    let completed = 0;

    pending.forEach(info => {
      this._userService.validateInduction(info.brandId, info.inductionId).subscribe({
        next: (result) => {
          if (result.success && result.siteInduction) {
            const idx = currentUser.siteInductionInfos.findIndex(
              s => s.brandId === info.brandId);
            if (idx >= 0) {
              currentUser.siteInductionInfos[idx] = result.siteInduction;
            }
          }
        },
        error: () => {
        },
        complete: async () => {
          completed++;
          if (completed >= pending.length) {
            await this._authService.setUser(currentUser);
            this.setCurrentUser(currentUser);
            if (this.isDebugModeActive) {
              await this.setDebugInfo();
            }
          }
        }
      });
    });
  }

  profileImageOnClick() {
    Camera.getPhoto({
      quality: 90,
      allowEditing: true,
      resultType: CameraResultType.DataUrl,
      direction: CameraDirection.Front
    }).then(
      image => {
        if (image && image?.dataUrl) {
          let imageFormatFromBase64String = this._utilsService.getBase64StringFileExtension(image?.dataUrl);
          this._authService.getFileSettings()
            .then(fs => {
              let formats = fs.supportedImages?.replace(/^,+|,+$/g, '').split(",").join("|");
              if (formats && formats.length > 0) {
                let matches = imageFormatFromBase64String.match(new RegExp(`(${formats})$\w?`));
                if (matches == null) {
                  alert(this._localizationService.translate("userprofile_invalid_filetype").replace('{supported_formats}', fs.supportedImages!.toLocaleUpperCase()));
                } else {
                  this.profileImgLink = image?.dataUrl;
                  this.newImagePath = image?.dataUrl;
                  this.newImageFormat = matches[0];
                }
              } else alert(this._localizationService.translate("userprofile_supported_fileformats_not_found"));
            });
        } else alert(this._localizationService.translate("userprofile_downloadfile_no_data_url_error"));
      },
      reject => {
        alert(reject);
      }
    );
  }

  private async setDebugInfo(){
    let latestLocation = this._geolocationService.getLatestLocation();
    if (latestLocation) {
      this.userLatLong = `${latestLocation.coords.latitude}, ${latestLocation.coords.longitude}`;
    }else{
      this.userLatLong = "Location not available";
    }

    this.deviceInfo = JSON.stringify(this._deviceService.getDeviceInfo());
  }

  public sendDebugInfoOnClick(){
    if (this.currentUser && this.isDebugModeActive) {
      var debugInfo = JSON.stringify({
        deviceInfo: this.deviceInfo,
        appVersion: this.appVersion,
        latLong: this.userLatLong,
        isSSO: this.isSSO,
        isNativePlatform: Capacitor.isNativePlatform(),
        isTablet: this._deviceService.isTablet(),
        isMobile: this._deviceService.isMobile()
      });

      var base64DebugInfo = this._utilsService.encodeBase64String(debugInfo);
      this._userdebuginfoService.updateRegisterStatus(base64DebugInfo).subscribe({
        next: (result) => { 
          if(result){
            alert("Successfully sent debug info.");
          }else{
            alert("Error sending debug info.");
          }
      },
        error: (error) => {
           alert("Error sending debug info." + error);
        }
      });
    }
  }

  updateLocationOnClick(){
    this.setDebugInfo();
  }

  public savePhotoOnClick() {
    if (this.currentUser && this.newImagePath) {
      var newFile = {
        fileType: this.newImageFormat ? this.newImageFormat : "",
        fileName: `${this.currentUser.id}.${this.newImageFormat}`
      } as UploadFileStorage;
      if (this.currentUser) {
        let imageFormatFromBase64String = this._utilsService.getBase64StringFileExtension(this.newImagePath);
        this.newImagePath = imageFormatFromBase64String === "jpg"
          ? this._utilsService.removeExifMetadataFromDataUrl(this.newImagePath)
          : this.newImagePath;
        newFile.file = this.newImagePath.split(",")[1];
        this._fileStorageService.UploadImage(newFile).subscribe({
          next: r => {
            if (r && this.currentUser && r.id != undefined) {
              this._userService.updateUserPhoto(this.currentUser?.id, r.id).subscribe({
                next: r => {
                  if (r) {
                    alert(this._localizationService.translate("userprofile_photo_updated"));
                    if (this.currentUser && this.newImagePath) {
                      this.currentUser.photo = this.newImagePath;
                      this._authService.setUser(this.currentUser);
                    }
                    this.newImagePath = undefined;
                    this.newImageFormat = undefined;
                  } else {
                    alert(this._localizationService.translate("error_return_empty"));
                  }
                },
                error: error => {
                  if (error.error && error.error.errorCode) {
                    alert(this._localizationService.translate(error.error.errorCode));
                  }
                  else {
                    alert(this._localizationService.translate('userprofile_error_updating_photo'));
                  }
                }
              });
            }
          },
          error: e => {
            if (e.error && e.error.errorCode) {
              alert(this._localizationService.translate(e.error.errorCode));
            }
            else {
              alert(this._localizationService.translate("userprofile_error_uploading_photo"));
            }
          }
        });
      }
    }
  }

  private getProfileImageLink(userPhoto: string) {
    if (environment.isDemo) {
      this.profileImgLink = userPhoto;
    } else {
      // Regular expression to check if string is a valid UUID
      const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;

      if (!regexExp.test(userPhoto)) {
        this.profileImgLink = userPhoto;
      } else {
        if (this.currentUser) {
          this._fileStorageService.download(userPhoto).subscribe(
            {
              next: file => {
                this.profileImgLink = `data:image/${file.fileType};base64,${file.file}`;
              },
              error: error => {
                if (error.error && error.error.errorCode) {
                  alert(this._localizationService.translate(error.error.errorCode));
                }
                else {
                  alert(this._localizationService.translate("user_profile_error_downloading_photo"));
                }
                this.profileImgLink = "";
              }
            });
        } else {
          this.profileImgLink = "";
        }
      }
    }
  }

  getCompanyNameByRapidGlobalompanyId(id: string): string {
    var result = "-";
    if (id && id.length > 0 && this.currentUser?.companies && this.currentUser?.companies.length > 0) {
      var company = this.currentUser.companies.find(c => c.id == id);
      if (company) {
        result = company.name;
      }
    }
    return result
  }

  deactivateUser() {
    let deactivateUserDialog: MatDialogRef<UserProfileDeleteComponent>;
    const dialogConfig = {
      data: { user: this.currentUser },
      disableClose: true,
      autoFocus: false,
      maxWidth: '100vw !important',
      maxHeight: '100vw !important',
      panelClass: 'details-container'
    };
    deactivateUserDialog = this._addDialog.open(UserProfileDeleteComponent, dialogConfig);
    deactivateUserDialog.addPanelClass('details-container');
    deactivateUserDialog.afterClosed().subscribe((returnValue) => {
      if (returnValue) {
        this._authService.logout().then(async _ => {
          this._router.navigate(['login']);
        });
      }
    });
  }

  onLangSelect(lang: string): void {
    this._localizationService.set(lang).then(() => {
      this.language = lang;
      this._localizationService.useLanguage(lang);
    });
    const locale = this.languages.find(l => l.code === lang)?.azureLocales;
    if (locale) {
      this._localizationService.setAzureLocale(locale);
    }
  }
}